import { render, staticRenderFns } from "./Cancelar.vue?vue&type=template&id=b86f190a"
import script from "./Cancelar.vue?vue&type=script&lang=js"
export * from "./Cancelar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports